import React from "react";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./GradeRow.scss";

const GradeRowSkeleton = () => {
  return (
    <div className={classes.leftContainer}>
      <SkeletonLoader width="36px" height="36px" borderRadius="4px" />
      <div className={classes.skeletonText}>
        <SkeletonLoader width="140px" height="14px" />
        <SkeletonLoader width="360px" height="16px" />
      </div>
    </div>
  );
};

export default GradeRowSkeleton;
